module.exports = __webpack_public_path__ + "static/media/table tennis.0cd3f778.webp";